// Support-centre walkthroughs, by LMS platform.
//
// A platform with no article yet is absent on purpose rather than falling back
// to another platform's: callers hide their link or iframe instead of sending
// an admin to instructions that don't describe their LMS. Adding a platform
// here lights it up in both the configuration wizard and the connection
// sidebar.
// A Map rather than an object literal: the platform comes off the configure
// response, and a plain lookup would resolve inherited members ('constructor',
// 'toString') to something truthy that ends up in an href.
export const DOCUMENTATION_URLS = new Map([
	[
		'brightspace',
		'https://support.pronto.io/en/articles/16788480-integrating-pronto-into-brightspace-d2l',
	],
])

export const getDocumentationUrl = (platform) =>
	DOCUMENTATION_URLS.get(platform) ?? null
